import { render, staticRenderFns } from "./CatalogueList.vue?vue&type=template&id=309a6e26&scoped=true&"
import script from "./CatalogueList.vue?vue&type=script&lang=js&"
export * from "./CatalogueList.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueList.vue?vue&type=style&index=0&id=309a6e26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309a6e26",
  null
  
)

export default component.exports